import React ,{Component} from 'react'
import { Form, Icon, Input, Button, Checkbox , Row , Col, message} from 'antd'
import {login} from '../../redux/auth/actions/actionCreators'
import dispatcher from '../../dispatcher/dispatcher';
import { connect } from 'react-redux';




class Login extends Component{

    constructor(){
        super()
        this.state ={
            username : "",
            password : "",
            remember : false,
            emp_type : "MANAGER"
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        console.log(e)
        this.props.login(this.props.server,{
          username : this.state.username,
          password : this.state.password,
          remember : this.state.remember,
          emp_type : this.state.emp_type
        }
        ,
        () => {
          message.success("Login successfull!")
        }
        ,
        () => {
          message.error("Login failed!")
        }
        )
        // dispatcher.dispatch({type : "LOGIN",data : this.state})

    }

    handleChange = (event) => {
        var state = {...this.state}
        switch (event.target.id)
        {
        
            case "normal_login_username" : {             
                state = {
                    "username" : event.target.value,
                    "password" : this.state.password,
                    "remember" : this.state.remember
                }                    
                break;
            }
            case "normal_login_password" :{
                state = {
                    "username" : this.state.username,
                    "password" : event.target.value,
                    "remember" : this.state.remember
                }
                 
                break;
            }
            case "normal_login_remember" :{
              state = {
                  "username" : this.state.username,
                  "password" : this.state.password,
                  "remember" : event.target.checked
              }
               
              break;
            }
            default:{
                //
            }
    
        }
        
        this.setState(state,()=>{console.log(this.state)})
        
    }
    
    
    render(){

        const { getFieldDecorator } = this.props.form;

        return(

          
                <Form onSubmit = {this.handleSubmit} >
                  
                  <Row style={{marginTop:"150px"}}>
                    <Col span={6} offset={9} style={{backgroundColor:"rgba(0, 0, 0, 0.05)" , padding:50}}>
                    <Form.Item style={{textAlign:"center"}}>
                        <img style={{width:"200px"}} src={this.props.entity=="SEGA" ? "img/sg_logo.jpg":"img/rm_logo.png"}/>
                    </Form.Item>
                    <Form.Item>
                      {getFieldDecorator('username', {
                        rules: [{ required: true, message: 'Please input your username!' }],
                      })(
                        <Input
                          prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          placeholder="Username"  onChange = {this.handleChange}
                          size="large"
                        />,
                      )}
                  </Form.Item>
                  <Form.Item>
                      {getFieldDecorator('password', {
                        rules: [{ required: true, message: 'Please input your Password!' }],
                      })(
                        <Input
                          prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          type="password"
                          placeholder="Password"
                          size="large"
                          onChange={this.handleChange}
                        />,
                      )}
                    </Form.Item>
                    <Form.Item>
                      {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: false,
                      })(<Checkbox onChange={this.handleChange}>Remember me</Checkbox>)}
                      <a style={{float:"Right" }} href="google.com">
                        Forgot password
                      </a>
                      <Button size="large" loading={this.props.auth.loading}  type="primary" htmlType="submit"  block>
                        Log in
                      </Button >
                    </Form.Item>
                  </Col>
                </Row>
                
                </Form>
                
        )
    }

    

}



const mapDispactToProps = dispatch => ({
    login : (server,data,successCallback,errorCallback) => dispatch(login(server,data,successCallback,errorCallback))
})

const mapStateToProps = state => ({
    auth: state.auth,
    server: state.entity.server,
    entity : state.entity.entity
})


export default connect(mapStateToProps,mapDispactToProps)(Form.create({ name: 'normal_login' })(Login))